import { render } from "./relatorioAPI.vue?vue&type=template&id=186c3a3d"
import script from "./relatorioAPI.vue?vue&type=script&lang=js"
export * from "./relatorioAPI.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__